import { render, staticRenderFns } from "./ClientListProps.vue?vue&type=template&id=5d0e0dd8&scoped=true&"
import script from "./ClientListProps.vue?vue&type=script&lang=js&"
export * from "./ClientListProps.vue?vue&type=script&lang=js&"
import style0 from "./ClientListProps.vue?vue&type=style&index=0&id=5d0e0dd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0e0dd8",
  null
  
)

export default component.exports